// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"FO7fph"};